module.exports = __webpack_public_path__ + "static/media/05.2026b223.png";